import { render, staticRenderFns } from "./CreateOrEditProjectCategoryDialog.vue?vue&type=template&id=34a6291b"
import script from "./CreateOrEditProjectCategoryDialog.ts?vue&type=script&lang=ts&external"
export * from "./CreateOrEditProjectCategoryDialog.ts?vue&type=script&lang=ts&external"
import style0 from "./CreateOrEditProjectCategoryDialog.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports